module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1509-9de1f107e844b623604c1bee2b523a42.png";